import React, { useState, useContext } from 'react';
import { UpgradePlan } from './styles';
import Button from '../Button';
import { withTranslation } from 'react-i18next';
import { UPGRADE_PLAN_MODAL as trans } from './translationValues';
import { createCustomerPortal } from '../../utils/services/authAPI';
import { AppStoreContext } from '../../context/appStoreContext';
import { Tooltip, message } from 'antd';

const namespaces = ['UPGRADE_PLAN_MODAL'];

const UpgradePlanModal = props => {
  const { visible, modalText, onCancel, t } = props;
  const [isLoading, setIsLoading] = useState(false);

  const { checkUserAccess, userDetails } = useContext(AppStoreContext);
  const isPremium = userDetails?.planMapping?.planName === 'Premium';

  const handleButtonClick = async () => {
    setIsLoading(true);
    const response = await createCustomerPortal();
    if (response?.updatePlanUrl) {
      onCancel();
      window.open(response.updatePlanUrl, '_blank');
    } else {
      message.error(t(trans.REDIRECTION_FAILED_ERROR_MESSAGE.key, trans.REDIRECTION_FAILED_ERROR_MESSAGE.value));
    }
    setIsLoading(false);
  };

  const UpgradeButton = ({ disable }) => {
    const buttonLabel = isPremium
    ? t(trans.OK_BUTTON.key, trans.OK_BUTTON.value)
    : t(trans.UPGRADE_BUTTON.key, trans.UPGRADE_BUTTON.value);
    const onClickHandler = isPremium ? onCancel : handleButtonClick;
    return (
      <Button
        loading={isLoading}
        label={isLoading ? t(trans.REDIRECTING_BUTTON.key, trans.REDIRECTING_BUTTON.value) : buttonLabel}
        large={true}
        onClick={onClickHandler}
        disabled={disable ? true : false}
      />
    );
  };

  return (
    <UpgradePlan
      width="600px"
      centered
      closable={false}
      visible={visible}
      footer={[
        <div className="footer">
          { !isPremium && <Button
            className={'cancel-button'}
            label={t(trans.CANCEL_BUTTON.key, trans.CANCEL_BUTTON.value)}
            large={true}
            onClick={onCancel}
          /> }
          {!(checkUserAccess('master', ['ADMIN']) || checkUserAccess('client', ['ADMIN'])) ? (
            <Tooltip placement="top" title={t(trans.UPGRADE_BUTTON_TOOLTIP_TEXT.key, trans.UPGRADE_BUTTON_TOOLTIP_TEXT.value)}>
              <div>
                <UpgradeButton disable={true} />
              </div>
            </Tooltip>
          ) : (
            <UpgradeButton disable={false} />
          )}
        </div>,
      ]}
    >
      <p dangerouslySetInnerHTML={{ __html: modalText }}></p>
    </UpgradePlan>
  );
};

export default withTranslation(namespaces)(UpgradePlanModal);
